import styled from 'styled-components';

export const List = styled.ul`
  gap: 8px;
  display: flex;
  padding: '4px 0';
  flex-wrap: wrap;
`;
